<template>
  <div class="custom-tooltip cursor-pointer">
    <slot />
    <div
      class="custom-tooltiptext arrow"
      :class="[bgColor, textColor, top, bottom, left, right, width, otherClass, tooltipPosition]"
    >
      <slot name="tooltip-content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomTooltip",

  props: {
    bgColor: { type: String, default: "bg-black" },
    textColor: { type: String, default: "text-gray-100" },
    top: { type: String, default: "" },
    bottom: { type: String, default: "" },
    right: { type: String, default: "" },
    left: { type: String, default: "" },
    width: { type: String, default: "" },
    otherClass: { type: String, default: "" },
    tooltipPosition: { type: String, default: "bottom" },
  },
}
</script>

<style scoped>
.custom-tooltip {
  position: relative;
}

.tooltip-input-focus:focus ~ .custom-tooltiptext.bottom {
  opacity: 1;
  z-index: 11;
}

/* Tooltip position css */
.custom-tooltip .custom-tooltiptext.bottom {
  opacity: 0;
  width: 180px;
  text-align: center;
  position: absolute;
  z-index: 1;
  top: 120%;
  left: 0;
  margin-left: -60px;
}

/*.custom-tooltip:hover .custom-tooltiptext.bottom {*/
/*  opacity: 1;*/
/*}*/

.custom-tooltip .custom-tooltiptext.left {
  opacity: 0;
  width: 180px;
  text-align: center;
  position: absolute;
  z-index: 1;
  top: -5px;
  right: 110%;
}

/*.custom-tooltip:hover .custom-tooltiptext.left {*/
/*  opacity: 1;*/
/*}*/

.custom-tooltip .custom-tooltiptext.top {
  opacity: 0;
  width: 180px;
  text-align: center;
  position: absolute;
  z-index: 1;
  bottom: 120%;
  left: 50%;
  margin-left: -60px;
}

/*.custom-tooltip:hover .custom-tooltiptext.top {*/
/*  opacity: 1;*/
/*}*/

.custom-tooltip .custom-tooltiptext.right {
  opacity: 0;
  width: 180px;
  text-align: center;
  position: absolute;
  z-index: 1;
  top: -5px;
  left: 110%;
}

/*.custom-tooltip:hover .custom-tooltiptext.right {*/
/*  opacity: 1;*/
/*}*/

/* Tooltip Arrow position css */

.custom-tooltip .arrow::after {
  content: "";
  position: absolute;
}

.custom-tooltip .bottom.arrow::after {
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}

.custom-tooltip .left.arrow::after {
  top: 50%;
  left: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent black;
}

.custom-tooltip .top.arrow::after {
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

.custom-tooltip .right.arrow::after {
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent black transparent transparent;
}
</style>
